'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.config(function ($stateProvider, $sceDelegateProvider, $urlRouterProvider, $ionicConfigProvider, $provide, $httpProvider, httpInterceptorsProvider, USER_ROLES) {

    // 定义一个$rootScope事件绑定函数 视图销毁后 顺带销毁事件
    $provide.decorator('$rootScope', function ($delegate) {
      Object.defineProperty($delegate.constructor.prototype, '$onRootScope', {
        value: function value(name, listener) {
          var unSubscribe = $delegate.$on(name, listener);
          this.$on('$destroy', unSubscribe);
          return unSubscribe;
        }, enumerable: false
      });
      return $delegate;
    });

    // 开启js滚动
    $ionicConfigProvider.scrolling.jsScrolling(true);

    // 配置$http服务
    $httpProvider.interceptors.push(httpInterceptorsProvider.interceptor);
    //$httpProvider.defaults.useXDomain = true;
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.defaults.headers.common['Accept'] = 'application/json,text/javascript,*/*';

    /**
     * 禁止ios 滑动返回
     */
    $ionicConfigProvider.platform.ios.views.swipeBackEnabled(false);

    /**
     * 切换页面的转换方式。默认 platform.
     */
    $ionicConfigProvider.views.transition('platform');
    /**
     * 视图元素缓存的最大数量。默认10
     */
    $ionicConfigProvider.views.maxCache(8);
    /**
     * 设置缓存而不在每次加载重置
     */
    $ionicConfigProvider.views.forwardCache(true);
    /**
     * 返回按钮图标
     */
    $ionicConfigProvider.backButton.icon('ion-ios-arrow-back');
    //$ionicConfigProvider.platform.android.backButton.icon('ion-ios-arrow-back');
    //$ionicConfigProvider.platform.ios.backButton.icon('ion-ios-arrow-back');
    /**
     * 返回按钮文本。默认back.
     */
    $ionicConfigProvider.backButton.text('返回');
    //$ionicConfigProvider.platform.android.backButton.text('返回');
    //$ionicConfigProvider.platform.ios.backButton.text('返回');
    /**
     * 如果以前的标题文本应该成为后退按钮的文本。这是iOS默认。
     */
    $ionicConfigProvider.platform.android.backButton.previousTitleText(true);
    $ionicConfigProvider.platform.ios.backButton.previousTitleText(true);
    /**
     * Tab 样式.安卓默认 striped ，IOS默认 standard.
     */
    $ionicConfigProvider.tabs.style('standard');
    /**
     * Tab 位置. 安卓默认 top IOS默认 bottom.
     */
    $ionicConfigProvider.tabs.position('bottom');
    /**
     * navBar的标题的对齐方式。默认platform.
     */
    $ionicConfigProvider.navBar.alignTitle('center');
    /**
     * 主导航栏按钮的对齐方式。默认 left.
     */
    $ionicConfigProvider.navBar.positionPrimaryButtons('platform');
    /**
     * 次导航栏按钮的对齐方式. 默认right.
     */
    $ionicConfigProvider.navBar.positionSecondaryButtons('platform');

    // 注册路由
    (0, _route2.default)(app, $stateProvider, $urlRouterProvider, USER_ROLES);
  });
};

var _route = require('./route.config');

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * APP config
 * 导入外部定义好的 controllers、directives、filters、modals、services...
 * 在模块的加载阶段 提供者注册和配置的过程中对模块进行配置
 * 唯一能够在应用启动前进行修改的部分
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/app/app.config.js
// module id = 33
// module chunks = 0